export default __webpack_public_path__ + "static/media/catering_responsive.3987af2e.png";